<template>
    <div>
        <!-- Show when Customer Record not exists -->
        <not-found
            v-if="!Object.keys(customerDetails).length && !showPageLoader"
        ></not-found>
        <!-- Show when Customer Record not exists -->

        <!-- When data is loading -->
        <base-table-spinner
            v-if="!Object.keys(customerDetails).length && showPageLoader"
        ></base-table-spinner>
        <!-- When data is loading -->

        <div
            v-if="Object.keys(customerDetails).length"
            class="card customer-info"
        >
            <customer-information
                :customer-details="customerDetails"
            ></customer-information>
        </div>
        <div
            v-if="
                Object.keys(customerDetails).length &&
                    customerDetails.kycSummary
            "
            class="filter-section sub-filter"
        >
            <h2>KYC Status Summary</h2>
        </div>
        <div
            v-if="
                Object.keys(customerDetails).length &&
                    customerDetails.kycSummary
            "
            class="card customer-info kyc-status-section"
        >
            <div class="row">
                <div class="col-md-12">
                    <h3>Name Screening</h3>
                </div>
                <div class="col-md-6 win-small-full">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-sanction"></i
                                    ><label>Sanction Hit</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger:
                                                customerDetails.kycSummary
                                                    .nameScreening.sanctionHit,
                                            success: !customerDetails.kycSummary
                                                .nameScreening.sanctionHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening
                                                        .sanctionHit,
                                                'icon-check': !customerDetails
                                                    .kycSummary.nameScreening
                                                    .sanctionHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-tomb"></i
                                    ><label>PEP Hit</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger:
                                                customerDetails.kycSummary
                                                    .nameScreening.pepHit,
                                            success: !customerDetails.kycSummary
                                                .nameScreening.pepHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening.pepHit,
                                                'icon-check': !customerDetails
                                                    .kycSummary.nameScreening
                                                    .pepHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 win-small-full">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-enforcement"></i
                                    ><label>Enforcement Hit</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger:
                                                customerDetails.kycSummary
                                                    .nameScreening
                                                    .enforcementHit,
                                            success: !customerDetails.kycSummary
                                                .nameScreening.enforcementHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening
                                                        .enforcementHit,
                                                'icon-check': !customerDetails
                                                    .kycSummary.nameScreening
                                                    .enforcementHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-blacklist"></i
                                    ><label>Client Black List Hit</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger:
                                                customerDetails.kycSummary
                                                    .nameScreening.blackListHit,
                                            success: !customerDetails.kycSummary
                                                .nameScreening.blackListHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening
                                                        .blackListHit,
                                                'icon-check': !customerDetails
                                                    .kycSummary.nameScreening
                                                    .blackListHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col-md-3">
                    <h3>Documents Verification</h3>
                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-documentation"></i>
                                    <label
                                        v-if="
                                            !customerDetails.kycSummary
                                                .documentationVerification
                                        "
                                        >Document Mismatched</label
                                    >
                                    <label
                                        v-if="
                                            !!customerDetails.kycSummary
                                                .documentationVerification
                                        "
                                        >Document Matched</label
                                    >
                                </div>
                                <div class="tag-status">
                                    <span
                                        :class="{
                                            danger: !customerDetails.kycSummary
                                                .documentationVerification,
                                            success: !!customerDetails
                                                .kycSummary
                                                .documentationVerification,
                                        }"
                                    >
                                        <i
                                            v-if="
                                                !customerDetails.kycSummary
                                                    .documentationVerification
                                            "
                                            class="icon-wrong"
                                        ></i>
                                        <i
                                            v-if="
                                                !!customerDetails.kycSummary
                                                    .documentationVerification
                                            "
                                            class="icon-check"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <h3>Self-declared PEP</h3>
                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-documentation"></i>
                                    <label>PEP</label>
                                </div>
                                <div class="tag-status">
                                    <span
                                        :class="{
                                            danger:
                                                customerDetails.riskRatings[19]
                                                    .level == 'high',
                                            success:
                                                customerDetails.riskRatings[19]
                                                    .level == 'low',
                                        }"
                                    >
                                        <i
                                            v-if="
                                                customerDetails.riskRatings[19]
                                                    .level == 'high'
                                            "
                                            class="icon-wrong"
                                        ></i>
                                        <i
                                            v-if="
                                                customerDetails.riskRatings[19]
                                                    .level == 'low'
                                            "
                                            class="icon-check"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <h3>Risk Rating</h3>

                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-graph"></i
                                    ><label>{{
                                        customerDetails.kycSummary.riskRating
                                            ? customerDetails.kycSummary
                                                  .riskRating
                                            : 'low' | capitalize
                                    }}</label>
                                </div>
                                <div class="tag-status">
                                    <span
                                        :class="{
                                            black:
                                                customerDetails.kycSummary
                                                    .riskRating === 'sanction',
                                            danger:
                                                customerDetails.kycSummary
                                                    .riskRating === 'high',
                                            success:
                                                customerDetails.kycSummary
                                                    .riskRating !==
                                                    'sanction' &&
                                                customerDetails.kycSummary
                                                    .riskRating !== 'high',
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .riskRating ===
                                                        'sanction' ||
                                                    customerDetails.kycSummary
                                                        .riskRating === 'high',
                                                'icon-check':
                                                    customerDetails.kycSummary
                                                        .riskRating !==
                                                        'sanction' ||
                                                    customerDetails.kycSummary
                                                        .riskRating !== 'high',
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="customerDetails.lastReview"
            class="filter-section sub-filter"
        >
            <h2>Last Review</h2>
            <div class="card customer-last-review">
                <div class="card-body">
                    <div
                        v-if="
                            customerDetails.lastReview &&
                                !customerDetails.lastReview.reviewBy
                                    .profilePicture
                        "
                        class="profile-pic"
                        :style="{
                            'background-image':
                                'url(' +
                                require('@/assets/images/dummy/dummy-user.png') +
                                ')',
                        }"
                    ></div>
                    <div
                        v-if="
                            customerDetails.lastReview &&
                                customerDetails.lastReview.reviewBy
                                    .profilePicture
                        "
                        v-authenticated-image="
                            'users/' +
                                customerDetails.lastReview.reviewBy
                                    .profilePicture
                        "
                        class="profile-pic"
                    ></div>
                    <div
                        v-if="customerDetails.lastReview"
                        class="details-section"
                    >
                        <h5>
                            {{ customerDetails.lastReview.reviewBy.firstName }}
                            {{ customerDetails.lastReview.reviewBy.lastName }}
                        </h5>
                        <span class="status-types">
                            {{
                                customerDetails.lastReview.reviewBy.roleName
                            }}</span
                        >
                        <span class="status-types">
                            {{
                                customerDetails.lastReview.createdAt
                                    | moment('MMM D, YYYY h:mm a')
                            }}
                        </span>
                        <p
                            class="date-content"
                            v-html="
                                getContent(customerDetails.lastReview.status)
                            "
                        ></p>
                        <p>
                            {{ customerDetails.lastReview.comment }}
                        </p>

                        <div
                            v-if="customerDetails.lastReview.attachment"
                            class="file-section"
                        >
                            <!-- <pdf-icon></pdf-icon> -->
                            <i
                                class="icon-cloud secondary-color icon-download"
                            ></i>
                        </div>
                        <div
                            v-if="customerDetails.lastReview.attachment"
                            class="file-attach"
                        >
                            <b-button
                                variant="link"
                                @click="
                                    downloadFile(
                                        customerDetails.lastReview.attachment
                                    )
                                "
                            >
                                <span class="btn-text"
                                    >Download Attachment</span
                                >
                            </b-button>
                        </div>
                    </div>
                    <base-status
                        :status-type="customerDetails.lastReview.status"
                    ></base-status>
                </div>
            </div>
        </div>
        <!-- <cancel-review-process-popup></cancel-review-process-popup>
        <kyc-status-review-popup></kyc-status-review-popup>
        <manual-alert-popup></manual-alert-popup> -->
        <file-preview-popup
            :customer-details="customerDetails"
        ></file-preview-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import customerInformation from '@/components/CustomerInfo.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'
import kycStatusReviewPopup from '@/components/popups/KYCStatusReviewPopup.vue'
import cancelReviewProcessPopup from '@/components/popups/CancelReviewProcessPopup.vue'
import manualAlertPopup from '@/components/popups/ManualAlertPopup.vue'
import tags from '@/components/Tags.vue'
import NotFound from '@/views/404/NotFound.vue'
import filePreviewPopup from '@/components/popups/FilePreviewPopup.vue'

import request from '@/utils/request'

import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        customerInformation,
        tags,
        cancelReviewProcessPopup,
        kycStatusReviewPopup,
        pdfIcon,
        manualAlertPopup,
        NotFound,
        filePreviewPopup,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            required: true,
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            customerDetails: {},
            tags: [],
            tagsList: [],
            image: 'member-1.png',
            name: 'Jacqueline Asong',
            subHeading: 'Approver',
            date: 'July 4, 2019 10:45 a.m.',
            // content:
            //     'Submitted KYC Review Status and changed KYC Status to <b>Approved</b> with the following comment,',
            details:
                '"I didn\'t found anything unusual with the profile. All records are clear and up to date."',

            status: [
                {
                    icon: 'icon-check',
                    label: 'Approved',
                    cssClass: 'approved',
                },
            ],
            showPageLoader: true,
        }
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        refreshProfile(value) {
            if (value) {
                this.initializeData()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.$router.push({ name: 'view-customer-profile' })
            }
        },
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['refreshProfile', 'dataSegmentId']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.initializeData()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         *
         * @return {void}
         */
        async initializeData() {
            try {
                if (!this.id) {
                    this.id = this.$route.params.id
                }
                let { data } = await request({
                    url: `customers/view-temp-customer/${this.id}`,
                })

                this.customerDetails = data.data
                // this.$store.commit('setCustomerRecord', data.data)
                // this.$store.commit('setRefreshProfile', false)
            } catch (error) {
                // console.log(error)
            }
            this.showPageLoader = false
        }, // End of initializeData() method

        getContent(status) {
            return (
                'Submitted KYC Review Status and changed KYC Status to <b>' +
                _.startCase(status) +
                '</b> with the following comment,'
            )
        }, // End of getContent() method

        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
        }, // End of forceFileDownload() method

        async downloadFile(fileName) {
            let fileUrl = 'customers/' + fileName
            try {
                let response = await request({
                    url: `/files/${fileUrl}`,
                    responseType: 'arraybuffer',
                })
                let fileExtension = response.headers['content-type']
                if (
                    fileExtension == 'image/png' ||
                    fileExtension == 'image/jpg' ||
                    fileExtension == 'image/jpeg'
                ) {
                    this.$bvModal.show('file-preview-popup')
                } else {
                    this.forceFileDownload(response, fileName)
                }
            } catch (err) {
                // console.log('Error occured: ', err)
            }
        }, // End of downloadFile() method
    }, // End of Component > mounted
} // End of export default
</script>
